function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
/**
 * Tesoro refused the file itself — its type, contents or size. Retrying the
 * same bytes cannot succeed, so the message (already user-facing, from
 * tesoro) is what the user needs to see.
 */ export class UploadRejectedError extends Error {
    constructor(...args){
        super(...args), _define_property(this, "name", 'UploadRejectedError');
    }
}
